import React, { useState, memo } from 'react';
import { connect } from 'react-redux';

import Popups from '../../components/Popup';
import { usePopupContext } from '../../contexts/PopupContext';

const DeleteRestartedAgreementPopupContainer = props => {
  const { closePopup } = usePopupContext();
  const [deleteType, setDeleteType] = useState(null);
  const id = props.popup.getIn(['props', 'id']);
  const sourceForAgreement = props.popup.getIn(['props', 'sourceForAgreement']);
  const removeCompanyRetainer = props.popup.getIn(['props', 'removeCompanyRetainer']);

  const handleClose = () => {
    closePopup();
  };

  const handleChange = event => {
    setDeleteType(event.target.value);
  };

  const handleDelete = () => {
    removeCompanyRetainer(id, deleteType);
    closePopup();
  };

  return (
    <Popups.DeleteRestartedAgreementPopup
      isDisabled={!deleteType}
      onChange={handleChange}
      onClose={handleClose}
      onDelete={handleDelete}
      sourceForAgreement={sourceForAgreement}
    />
  );
};

const mapStateToProps = state => ({
  linkedCompanyRetainers: state.targetCompany.buyer.retainer.get('linkedCompanyRetainers'),
});

export { DeleteRestartedAgreementPopupContainer };
export default connect(mapStateToProps, null)(memo(DeleteRestartedAgreementPopupContainer));
